import slices from './slices';

export default {
  ...slices.postsSlice.actions,
  ...slices.chatsSlice.actions,
  ...slices.activeSlice.actions,
  ...slices.chatMessagesSlice.actions,
};
